import { Component } from "react";
import { Box, Typography, Link } from "@mui/material";
import notFoundImage from "../../assets/404.png";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("Caught by ErrorBoundary:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            p: 3,
            backgroundColor: "#F5F7FA",
          }}
        >
          <Box
            component="img"
            src={notFoundImage}
            alt="Something went wrong"
            sx={{
              width: { xs: 220, sm: 340 },
              mb: 2,
            }}
          />

          <Typography variant="h5" sx={{ color: "text.secondary", mb: 1 }}>
            Oops, something went wrong.
          </Typography>

          <Link
            onClick={() => this.setState({ hasError: false, error: null })}
            underline="none"
            sx={{
              mt: 2,
              px: 3,
              py: 1,
              borderRadius: "999px",
              fontSize: "1rem",
              fontWeight: 600,
              color: "#09b2f0",
              border: "2px solid #09b2f0",
              backgroundColor: "#FFFFFF",
              transition: "all 0.2s ease",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#09b2f0",
                color: "#FFFFFF",
              },
            }}
          >
            ← Go back
          </Link>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
